import qs from "qs";
import { soddApi } from "./soddApi";

function formatParams(params) {
    return qs.stringify(params, {
        arrayFormat: "brackets",
        skipNulls: true,
        filter: (prefix, value) => value || undefined,
    });
}

export const tagApi = soddApi
    .enhanceEndpoints({
        addTagTypes: ["tag"],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getTags: build.query({
                query: (params) => ({
                    url: "api/v1/forms/field-options/tags",
                    params: formatParams(params),
                }),
                providesTags: ["tag"],
            }),
        }),
    });
